.al{overflow:hidden;}